var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_116_113)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.0339 18C7.88427 17.969 7.732 17.948 7.58527 17.9061C6.64445 17.6451 6.05014 16.9309 6.00871 15.9582C5.96569 14.9536 6.07917 13.9632 6.46526 13.0225C6.71544 12.4152 7.07884 11.89 7.68898 11.5689C8.05715 11.3732 8.47073 11.2754 8.88895 11.2852C9.0209 11.2878 9.16182 11.3541 9.28322 11.4191C9.47877 11.5231 9.66007 11.6531 9.84982 11.7696C10.9535 12.4409 12.057 12.4401 13.1605 11.767C13.3135 11.6737 13.4698 11.5834 13.6139 11.4771C13.8778 11.2824 14.1681 11.2579 14.4816 11.3034C15.3374 11.4272 15.942 11.8892 16.3495 12.6258C16.7134 13.2836 16.8773 13.9981 16.9501 14.7341C16.9878 15.1128 17.0046 15.4932 17.0005 15.8737C16.9865 17.0078 16.1967 17.8518 15.0516 17.9763C15.023 17.9817 14.995 17.9896 14.9679 18H8.0339Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.599 8.12597C14.6109 9.83885 13.1758 11.26 11.4274 11.265C9.67908 11.2699 8.23976 9.85029 8.23897 8.14209C8.23651 7.31202 8.56851 6.51492 9.16207 5.9258C9.75562 5.33668 10.5622 5.00371 11.4047 5C13.1626 4.98726 14.5885 6.38215 14.599 8.12597Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_116_113"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 13,
    fill: "white",
    transform: "translate(6 5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.ad3db8d54c2a952aed2966c16d2a364b.svg";
export { ForwardRef as ReactComponent };